import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { createNoDashGuid } from "../../../src/common/Guid";
import { connectivity, type } from "../../common.speech/Exports";
import { AudioSourceInitializingEvent, AudioSourceReadyEvent, AudioStreamNodeAttachedEvent, AudioStreamNodeAttachingEvent, AudioStreamNodeDetachedEvent, ChunkedArrayBufferStream, Events, EventSource, PromiseHelper } from "../../common/Exports";
import { AudioStreamFormat } from "../Exports";
import { AudioStreamFormatImpl } from "./AudioStreamFormat";
export var bufferSize = 4096;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @class AudioInputStream
 */

export var AudioInputStream = /*#__PURE__*/function () {
  /**
   * Creates and initializes an instance.
   * @constructor
   */
  function AudioInputStream() {
    _classCallCheck(this, AudioInputStream);
  }
  /**
   * Creates a memory backed PushAudioInputStream with the specified audio format.
   * @member AudioInputStream.createPushStream
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   *        written to the push audio stream's write() method (currently only support 16 kHz 16bit mono PCM).
   * @returns {PushAudioInputStream} The audio input stream being created.
   */


  _createClass(AudioInputStream, null, [{
    key: "createPushStream",
    value: function createPushStream(format) {
      return PushAudioInputStream.create(format);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     *        PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     *        the callback's read() method (currently only support 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */

  }, {
    key: "createPullStream",
    value: function createPullStream(callback, format) {
      return PullAudioInputStream.create(callback, format); // throw new Error("Oops");
    }
  }]);

  return AudioInputStream;
}();
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @class PushAudioInputStream
 */
// tslint:disable-next-line:max-classes-per-file

export var PushAudioInputStream = /*#__PURE__*/function (_AudioInputStream) {
  _inherits(PushAudioInputStream, _AudioInputStream);

  function PushAudioInputStream() {
    _classCallCheck(this, PushAudioInputStream);

    return _possibleConstructorReturn(this, _getPrototypeOf(PushAudioInputStream).apply(this, arguments));
  }

  _createClass(PushAudioInputStream, null, [{
    key: "create",

    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     *        push audio stream's write() method (currently only support 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */
    value: function create(format) {
      return new PushAudioInputStreamImpl(bufferSize, format);
    }
  }]);

  return PushAudioInputStream;
}(AudioInputStream);
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @private
 * @class PushAudioInputStreamImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var PushAudioInputStreamImpl = /*#__PURE__*/function (_PushAudioInputStream) {
  _inherits(PushAudioInputStreamImpl, _PushAudioInputStream);

  /**
   * Creates and initalizes an instance with the given values.
   * @constructor
   * @param {AudioStreamFormat} format - The audio stream format.
   */
  function PushAudioInputStreamImpl(chunkSize, format) {
    var _this;

    _classCallCheck(this, PushAudioInputStreamImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PushAudioInputStreamImpl).call(this));

    _this.onEvent = function (event) {
      _this.privEvents.onEvent(event);

      Events.instance.onEvent(event);
    };

    if (format === undefined) {
      _this.privFormat = AudioStreamFormatImpl.getDefaultInputFormat();
    } else {
      _this.privFormat = format;
    }

    _this.privEvents = new EventSource();
    _this.privId = createNoDashGuid();
    _this.privStream = new ChunkedArrayBufferStream(chunkSize);
    return _this;
  }
  /**
   * Format information for the audio
   */


  _createClass(PushAudioInputStreamImpl, [{
    key: "write",

    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */
    value: function write(dataBuffer) {
      this.privStream.writeStreamChunk({
        buffer: dataBuffer,
        isEnd: false,
        timeReceived: Date.now()
      });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */

  }, {
    key: "close",
    value: function close() {
      this.privStream.close();
    }
  }, {
    key: "id",
    value: function id() {
      return this.privId;
    }
  }, {
    key: "turnOn",
    value: function turnOn() {
      this.onEvent(new AudioSourceInitializingEvent(this.privId)); // no stream id

      this.onEvent(new AudioSourceReadyEvent(this.privId));
      return PromiseHelper.fromResult(true);
    }
  }, {
    key: "attach",
    value: function attach(audioNodeId) {
      var _this2 = this;

      this.onEvent(new AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
      return this.turnOn().onSuccessContinueWith(function (_) {
        // For now we support a single parallel reader of the pushed stream.
        // So we can simiply hand the stream to the recognizer and let it recognize.
        return _this2.privStream.getReader();
      }).onSuccessContinueWith(function (streamReader) {
        _this2.onEvent(new AudioStreamNodeAttachedEvent(_this2.privId, audioNodeId));

        return {
          detach: function detach() {
            streamReader.close();

            _this2.onEvent(new AudioStreamNodeDetachedEvent(_this2.privId, audioNodeId));

            _this2.turnOff();
          },
          id: function id() {
            return audioNodeId;
          },
          read: function read() {
            return streamReader.read();
          }
        };
      });
    }
  }, {
    key: "detach",
    value: function detach(audioNodeId) {
      this.onEvent(new AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
  }, {
    key: "turnOff",
    value: function turnOff() {
      return PromiseHelper.fromResult(false);
    }
  }, {
    key: "format",
    get: function get() {
      return this.privFormat;
    }
  }, {
    key: "events",
    get: function get() {
      return this.privEvents;
    }
  }, {
    key: "deviceInfo",
    get: function get() {
      return PromiseHelper.fromResult({
        bitspersample: this.privFormat.bitsPerSample,
        channelcount: this.privFormat.channels,
        connectivity: connectivity.Unknown,
        manufacturer: "Speech SDK",
        model: "PushStream",
        samplerate: this.privFormat.samplesPerSec,
        type: type.Stream
      });
    }
  }]);

  return PushAudioInputStreamImpl;
}(PushAudioInputStream);
/*
 * Represents audio input stream used for custom audio input configurations.
 * @class PullAudioInputStream
 */
// tslint:disable-next-line:max-classes-per-file

export var PullAudioInputStream = /*#__PURE__*/function (_AudioInputStream2) {
  _inherits(PullAudioInputStream, _AudioInputStream2);

  /**
   * Creates and initializes and instance.
   * @constructor
   */
  function PullAudioInputStream() {
    _classCallCheck(this, PullAudioInputStream);

    return _possibleConstructorReturn(this, _getPrototypeOf(PullAudioInputStream).call(this));
  }
  /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @member PullAudioInputStream.create
   * @function
   * @public
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   *        derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   *        returned from the callback's read() method (currently only support 16 kHz 16bit mono PCM).
   * @returns {PullAudioInputStream} The push audio input stream being created.
   */


  _createClass(PullAudioInputStream, null, [{
    key: "create",
    value: function create(callback, format) {
      return new PullAudioInputStreamImpl(callback, format);
    }
  }]);

  return PullAudioInputStream;
}(AudioInputStream);
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class PullAudioInputStreamImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var PullAudioInputStreamImpl = /*#__PURE__*/function (_PullAudioInputStream) {
  _inherits(PullAudioInputStreamImpl, _PullAudioInputStream);

  /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @constructor
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   *        derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   *        returned from the callback's read() method (currently only support 16 kHz 16bit mono PCM).
   */
  function PullAudioInputStreamImpl(callback, format) {
    var _this3;

    _classCallCheck(this, PullAudioInputStreamImpl);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PullAudioInputStreamImpl).call(this));

    _this3.onEvent = function (event) {
      _this3.privEvents.onEvent(event);

      Events.instance.onEvent(event);
    };

    if (undefined === format) {
      _this3.privFormat = AudioStreamFormat.getDefaultInputFormat();
    } else {
      _this3.privFormat = format;
    }

    _this3.privEvents = new EventSource();
    _this3.privId = createNoDashGuid();
    _this3.privCallback = callback;
    _this3.privIsClosed = false;
    return _this3;
  }
  /**
   * Format information for the audio
   */


  _createClass(PullAudioInputStreamImpl, [{
    key: "close",

    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */
    value: function close() {
      this.privIsClosed = true;
      this.privCallback.close();
    }
  }, {
    key: "id",
    value: function id() {
      return this.privId;
    }
  }, {
    key: "turnOn",
    value: function turnOn() {
      this.onEvent(new AudioSourceInitializingEvent(this.privId)); // no stream id

      this.onEvent(new AudioSourceReadyEvent(this.privId));
      return PromiseHelper.fromResult(true);
    }
  }, {
    key: "attach",
    value: function attach(audioNodeId) {
      var _this4 = this;

      this.onEvent(new AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
      return this.turnOn().onSuccessContinueWith(function (result) {
        _this4.onEvent(new AudioStreamNodeAttachedEvent(_this4.privId, audioNodeId));

        return {
          detach: function detach() {
            _this4.privCallback.close();

            _this4.onEvent(new AudioStreamNodeDetachedEvent(_this4.privId, audioNodeId));

            _this4.turnOff();
          },
          id: function id() {
            return audioNodeId;
          },
          read: function read() {
            var totalBytes = 0;
            var transmitBuff; // Until we have the minimum number of bytes to send in a transmission, keep asking for more.

            while (totalBytes < bufferSize) {
              // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
              // data back.
              var readBuff = new ArrayBuffer(bufferSize - totalBytes);

              var pulledBytes = _this4.privCallback.read(readBuff); // If there is no return buffer yet defined, set the return buffer to the that was just populated.
              // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
              // preferred size allocated.


              if (undefined === transmitBuff) {
                transmitBuff = readBuff;
              } else {
                // Not the first bite at the apple, so fill the return buffer with the data we got back.
                var intView = new Int8Array(transmitBuff);
                intView.set(new Int8Array(readBuff), totalBytes);
              } // If there are no bytes to read, just break out and be done.


              if (0 === pulledBytes) {
                break;
              }

              totalBytes += pulledBytes;
            }

            return PromiseHelper.fromResult({
              buffer: transmitBuff.slice(0, totalBytes),
              isEnd: _this4.privIsClosed || totalBytes === 0,
              timeReceived: Date.now()
            });
          }
        };
      });
    }
  }, {
    key: "detach",
    value: function detach(audioNodeId) {
      this.onEvent(new AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
  }, {
    key: "turnOff",
    value: function turnOff() {
      return PromiseHelper.fromResult(false);
    }
  }, {
    key: "format",
    get: function get() {
      return this.privFormat;
    }
  }, {
    key: "events",
    get: function get() {
      return this.privEvents;
    }
  }, {
    key: "deviceInfo",
    get: function get() {
      return PromiseHelper.fromResult({
        bitspersample: this.privFormat.bitsPerSample,
        channelcount: this.privFormat.channels,
        connectivity: connectivity.Unknown,
        manufacturer: "Speech SDK",
        model: "PullStream",
        samplerate: this.privFormat.samplesPerSec,
        type: type.Stream
      });
    }
  }]);

  return PullAudioInputStreamImpl;
}(PullAudioInputStream);